/* eslint-disable import/no-mutable-exports */
/* eslint-disable fp/no-mutation */
/* eslint-disable fp/no-let */
let indiaAuthSignatureSrc;
try {
  indiaAuthSignatureSrc = new URL('../../../images/ind_auth_signature.png', import.meta.url).href;
} catch (e) {
  // for Jest testing environment
  indiaAuthSignatureSrc = 'ind_auth_signature_mock.png';
}
export default indiaAuthSignatureSrc;
